// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"layouts_Breadcrumb__PvRp9","Sidebar":"layouts_Sidebar__ABEut","blocktable":"layouts_blocktable__emGFW","blockContent":"layouts_blockContent__gewRv"};